import { render, staticRenderFns } from "./ChapterItem.vue?vue&type=template&id=f447c10c&scoped=true&"
import script from "./ChapterItem.vue?vue&type=script&lang=ts&"
export * from "./ChapterItem.vue?vue&type=script&lang=ts&"
import style0 from "./ChapterItem.vue?vue&type=style&index=0&id=f447c10c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f447c10c",
  null
  
)

export default component.exports